module.exports = __webpack_public_path__ + "static/media/news-suicide-prevention-awareness.c24f0e56.jpg";